// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.outstanding {
  width: 100px;
  height: 40px;
}

.paid {
  width: 100px;
}

.balance-row {
  margin: 15px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
}

.pay-container {
  height: 150px;
  background-color: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  text-align: center;
  width: 100%;
  position: fixed;
  bottom: 0px;
  border-radius: 20px 20px 0px 0px !important;
  padding-top: 1em;
}

.deposit-error-container {
  height: 250px;
  background-color: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  text-align: center;
  width: 100%;
  position: fixed;
  bottom: 0px;
  border-radius: 20px 20px 0px 0px !important;
  padding-top: 1em;
}

.balance-scroll-container {
  /* height: 72vh; */
  overflow: auto;
  margin-bottom: 130px;
}

.material-icons {
  font-size: 30px;
  height: 30px;
  width: 30px;
}

.icon-align {
  display: block;
  margin: auto;
}

.material-inventory-icon {
  font-size: 30px;
  height: 30px;
  width: 30px;
}

.color-red {
  color: red;
}

.balance-title {
  padding-top: 8px;
}

@media (min-width: 1024px) and (max-width: 1640px) {
  .balance-align {
    box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.1), 0px 15px 30px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    padding: 2em;
    width: 65%;
    flex-direction: column;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
  }
  .pay-container {
    height: 150px;
    background-color: white;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    text-align: center;
    width: 65%;
    position: fixed;
    bottom: 0px;
    border-radius: 20px 20px 0px 0px !important;
    padding-top: 1em;
    margin-left: -2em;
  }
  .deposit-error-container {
    height: 250px;
    background-color: white;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    text-align: center;
    width: 65%;
    position: fixed;
    bottom: 0px;
    border-radius: 20px 20px 0px 0px !important;
    padding-top: 1em;
    margin-left: -2em;
  }
}
@media (min-width: 1641px) {
  .balance-align {
    box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.1), 0px 15px 30px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    padding: 2em;
    width: 40%;
    flex-direction: column;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
  }
  .pay-container {
    height: 150px;
    background-color: white;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    text-align: center;
    width: 40%;
    position: fixed;
    bottom: 0px;
    border-radius: 20px 20px 0px 0px !important;
    padding-top: 1em;
    margin-left: -2em;
  }
  .deposit-error-container {
    height: 250px;
    background-color: white;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    text-align: center;
    width: 40%;
    position: fixed;
    bottom: 0px;
    border-radius: 20px 20px 0px 0px !important;
    padding-top: 1em;
    margin-left: -2em;
  }
}
.warning-icon {
  font-size: 50px;
  text-align: center;
  height: 50px;
  width: 50px;
  color: #ffca28;
}

.check-icon {
  font-size: 60px !important;
  color: #41c300;
  width: 70px !important;
  height: 70px !important;
}

@media (max-width: 1023px) {
  .check-icon-wrapper {
    margin-top: 10em;
  }
}
.icon-content {
  padding-top: 3em;
  padding-bottom: 3em;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
